import React from "react";
import { compose, withProps } from "recompose";
import { XeroClient } from "services";
import { withSelectedOrganisation } from "../components/withSelectedOrganisation";

const OrganisationContext = React.createContext();

export const withOrganisationContextProvider = compose(
  withProps((parentProps) => ({ parentProps })),
  withSelectedOrganisation(),
  (BaseComponent) =>
    class OrganisationContextProvider extends React.Component {
      fetchOrganisation = () =>
        this.fetchPromise("organisationPromise", "organisations").get(0);
      fetchTaxRates = () => this.fetchPromise("taxRatesPromise", "taxrates");
      fetchCurrencies = () =>
        this.fetchPromise("currenciesPromise", "currencies");
      fetchAccounts = () => this.fetchPromise("accountsPromise", "accounts");
      fetchItems = () => this.fetchPromise("itemsPromise", "items");
      fetchUser = () => this.fetchPromise("userPromise", "all/current_user");
      fetchSettings = () =>
        this.fetchPromise("settingsPromise", "all/invoice_settings");

      clearContext = (key) => {
        if (key) {
          this[`${key}Promise`] = null;
        } else {
          this.organisationPromise = null;
          this.taxRatesPromise = null;
          this.currenciesPromise = null;
          this.accountsPromise = null;
          this.itemsPromise = null;
          this.settingsPromise = null;
          this.userPromise = null;
        }
      };

      value = {
        fetchOrganisation: this.fetchOrganisation,
        fetchTaxRates: this.fetchTaxRates,
        fetchCurrencies: this.fetchCurrencies,
        fetchAccounts: this.fetchAccounts,
        fetchItems: this.fetchItems,
        fetchUser: this.fetchUser,
        fetchSettings: this.fetchSettings,
        clearContext: this.clearContext,
      };

      componentDidUpdate = (prevProps) => {
        if (
          this.props.selectedOrganisation !== prevProps.selectedOrganisation
        ) {
          this.clearContext();
        }
      };

      fetchPromise = (key, endpoint) => {
        const promise = this[key];
        if (!promise || promise.isRejected()) {
          this[key] = XeroClient().get(endpoint).get("data");
          return this[key];
        }
        return promise;
      };

      render = () => {
        return (
          <OrganisationContext.Provider value={this.value}>
            <BaseComponent {...this.props.parentProps} />
          </OrganisationContext.Provider>
        );
      };
    }
);

export const withOrganisationContextConsumer = (BaseComponent) => (props) => {
  return (
    <OrganisationContext.Consumer>
      {(context) => <BaseComponent {...props} {...context} />}
    </OrganisationContext.Consumer>
  );
};
